module.exports = __webpack_public_path__ + "static/media/white-square-logo.eaea4789.png";